const organizationsKey = 'accureOrganizations';

let memoryFallback: string[] = [];

function readOrganizations(): string[] {
  try {
    const raw = localStorage.getItem(organizationsKey);
    const parsed = JSON.parse(raw || '[]') as string[];
    memoryFallback = [...parsed];
    return parsed;
  } catch {
    return [...memoryFallback];
  }
}

function writeOrganizations(organizations: string[]): void {
  memoryFallback = [...organizations];
  try {
    localStorage.setItem(organizationsKey, JSON.stringify(organizations));
  } catch {
    void 0;
  }
}

export function getOrganizations(): {
  organizations: string[];
  setOrganizations: (organizations: string[]) => void;
} {
  return {
    organizations: readOrganizations(),
    setOrganizations: writeOrganizations,
  };
}
